"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = exports.Toast = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ui = require("@dcl/ui");

var _ToastTypes = require("./ToastTypes");

var _constants = require("./constants");

var _InformationIcon = _interopRequireDefault(require("./Icons/InformationIcon"));

var _SuccessIcon = _interopRequireDefault(require("./Icons/SuccessIcon"));

var _CautionIcon = _interopRequireDefault(require("./Icons/CautionIcon"));

var _WarningIcon = _interopRequireDefault(require("./Icons/WarningIcon"));

var _CloseIcon = _interopRequireDefault(require("./Icons/CloseIcon"));

var _Button = _interopRequireDefault(require("../../elements/Button/Button"));

var _ButtonTypes = require("../../elements/Button/ButtonTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Toast = function Toast(_ref) {
  var children = _ref.children,
      id = _ref.id,
      remove = _ref.remove,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? _ToastTypes.ToastType.SUCCESS : _ref$type,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? _constants.DEFAULT_TOAST_DURATION_MS : _ref$duration,
      _ref$closeButton = _ref.closeButton,
      closeButton = _ref$closeButton === void 0 ? true : _ref$closeButton;
  var getClassName = (0, _ui.getClassNameFactory)(Toast.displayName);
  var handleRemove = (0, _react.useCallback)(function () {
    if (remove && id) {
      remove(id);
    }
  }, [remove, id]);
  (0, _react.useEffect)(function () {
    // eslint-disable-next-line max-statements-per-line
    if (duration === 0) {
      return;
    }

    var timeoutId = setTimeout(handleRemove, duration);
    return function () {
      return clearTimeout(timeoutId);
    };
  }, [handleRemove, duration]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: getClassName({
      modifiers: type
    }),
    "data-type": type
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: getClassName({
      descendantName: "icon"
    })
  }, /*#__PURE__*/_react["default"].createElement(Icon, {
    type: type
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: getClassName({
      descendantName: "text"
    })
  }, children), closeButton && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: _ButtonTypes.ButtonColor.TERTIARY,
    kind: _ButtonTypes.ButtonKind.BUTTON,
    onClick: handleRemove,
    "aria-label": "close toast",
    "data-testid": "closeButton"
  }, /*#__PURE__*/_react["default"].createElement(_CloseIcon["default"], null)));
};

exports.Toast = Toast;

var Icon = function Icon(_ref2) {
  var type = _ref2.type;

  switch (type) {
    case _ToastTypes.ToastType.SUCCESS:
      return /*#__PURE__*/_react["default"].createElement(_SuccessIcon["default"], null);

    case _ToastTypes.ToastType.WARNING:
      return /*#__PURE__*/_react["default"].createElement(_WarningIcon["default"], null);

    case _ToastTypes.ToastType.CAUTION:
      return /*#__PURE__*/_react["default"].createElement(_CautionIcon["default"], null);

    case _ToastTypes.ToastType.INFO:
      return /*#__PURE__*/_react["default"].createElement(_InformationIcon["default"], null);

    default:
      return /*#__PURE__*/_react["default"].createElement(_SuccessIcon["default"], null);
  }
};

exports.Icon = Icon;
Toast.displayName = "Toast";